import { Text as HeadlessText } from '@zillow/constellation-headless/components/text/text';
import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { textRecipe } from './styles/text.styles';
import type { TextPropsInterface } from './types/text.types';

/**
 * @since 6.0.0
 */

export const Text = forwardRef<HTMLSpanElement, TextPropsInterface>(
  (props: TextPropsInterface, forwardedRef) => {
    const { className, color = 'text.neutral', css: cssProp, textStyle = 'body', ...rest } = props;

    const styles = css(textRecipe.raw({ color, textStyle }), cssProp);

    return (
      <HeadlessText
        ref={forwardedRef}
        className={cx('c11n', 'c11n_text', 'c11n-semantic', styles, className)}
        {...rest}
      />
    );
  },
);

Text.displayName = 'Text';
